import React, {useMemo} from 'react'

import cn from 'classnames/bind'

import s from './Progress.module.scss'

const cx = cn.bind(s)

interface IProgressProps {
	value: number
	children?: React.ReactNode
}

const Progress = ({value}: IProgressProps) => {
	const widthStyle = useMemo(() => {
		return {
			width: `${value}%`,
		}
	}, [value])

	return (
		<div className={cx('progress', value >= 100 && 'progress--complete')}>
			<div className={cx('progress__value')}>{value}% complete</div>
			<div className={cx('progress__wrapper')}>
				<div className={cx('progress__percentage')} style={widthStyle} />
			</div>
		</div>
	)
}

export default Progress
